import { has, keyBy } from 'lodash';
import { useMemo, useCallback } from 'react';
import { useHolidayCalendars } from 'queries/holiday-calendar';
export const useHolidayCalendar = (holidayCalendarId)=>{
    const { data: holidayCalendarsLookup } = useHolidayCalendars();
    const enabledHolidayCalendarsLookup = useMemo(()=>keyBy(Object.values(holidayCalendarsLookup || {}).filter((calendar)=>calendar.enabled), 'holidayCalendarId'), [
        holidayCalendarsLookup
    ]);
    const enabledHolidayCalendars = useMemo(()=>Object.values(holidayCalendarsLookup || {}).filter((calendar)=>calendar.enabled), [
        holidayCalendarsLookup
    ]);
    let holidayCalendar;
    if (holidayCalendarId) {
        holidayCalendar = has(enabledHolidayCalendarsLookup, holidayCalendarId) ? enabledHolidayCalendarsLookup[holidayCalendarId] : undefined;
    }
    const getCalendarHolidays = useCallback((holidayCalendarIdValue)=>{
        let holidays = [];
        if (holidayCalendarIdValue) {
            holidays = has(enabledHolidayCalendarsLookup, holidayCalendarIdValue) ? enabledHolidayCalendarsLookup[holidayCalendarIdValue].holidays : [];
        }
        return holidays || [];
    }, [
        enabledHolidayCalendarsLookup
    ]);
    return {
        enabledHolidayCalendars,
        holidayCalendar,
        getCalendarHolidays
    };
};
